import { WorkflowType } from './workflowType';

interface Props {
  uid: string;
  workflowType: WorkflowType;
  content: any;
  isRequired: boolean;
  choices?: Choice[];
  hasOtherChoice: boolean;
}

export interface Choice {
  uid: string;
  value: string;
}

export default class Workflow {
  uid: string;
  workflowType: WorkflowType;
  content: any;
  isRequired: boolean;
  choices?: Choice[];
  hasOtherChoice: boolean;

  constructor(props: Props) {
    this.uid = props.uid;
    this.workflowType = props.workflowType;
    this.content = props.content;
    this.isRequired = props.isRequired;
    this.choices = props.choices || [];
    this.hasOtherChoice = props.hasOtherChoice || false;
  }
}
